import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function HealthGrades(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#EA8A3E" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M10.3548 11.63V15.4964H11.4401V11.3994C11.4401 10.8386 11.3971 10.3751 11.3112 10.0088C11.2253 9.64255 11.0896 9.35088 10.9042 9.13382C10.7188 8.91676 10.4859 8.76527 10.2056 8.67935C9.92519 8.59343 9.59508 8.55047 9.21522 8.55047C8.72683 8.55047 8.31758 8.63412 7.98747 8.80144C7.65735 8.96876 7.37472 9.1926 7.13957 9.47298H7.08531V6H6V15.4964H7.08531V10.9788C7.18479 10.5447 7.40637 10.1897 7.75005 9.91388C8.09374 9.63803 8.47811 9.50011 8.90319 9.50011C9.20165 9.50011 9.44358 9.54533 9.62899 9.63577C9.8144 9.72621 9.96136 9.85961 10.0699 10.036C10.1784 10.2123 10.253 10.4339 10.2937 10.7007C10.3344 10.9675 10.3548 11.2773 10.3548 11.63ZM17.3016 17.7484C17.7674 17.3324 18.0003 16.6857 18.0003 15.8084V8.99815C17.7108 8.88962 17.383 8.79466 17.0167 8.71326C16.6504 8.63186 16.2095 8.59116 15.694 8.59116C14.6177 8.59116 13.8038 8.89188 13.2521 9.49332C12.7004 10.0948 12.4245 10.9743 12.4245 12.132C12.4245 13.3349 12.6393 14.2212 13.0689 14.791C13.4985 15.3608 14.17 15.6456 15.0835 15.6456C15.5357 15.6456 15.902 15.5756 16.1824 15.4354C16.4627 15.2952 16.6934 15.0939 16.8743 14.8317H16.9285V15.4828C16.9285 15.8265 16.9014 16.1227 16.8471 16.3714C16.7929 16.6202 16.6934 16.8237 16.5487 16.9819C16.404 17.1402 16.2118 17.2533 15.9721 17.3211C15.7324 17.3889 15.4227 17.4228 15.0428 17.4228C14.6358 17.4228 14.3057 17.3867 14.0525 17.3143C13.7992 17.2419 13.5686 17.1651 13.3606 17.0837L13.0757 18.0062C13.3108 18.1147 13.5935 18.2029 13.9236 18.2707C14.2537 18.3386 14.6901 18.3725 15.2327 18.3725C16.1462 18.3725 16.8358 18.1645 17.3016 17.7484ZM16.3587 14.3501C16.0964 14.5807 15.7347 14.696 15.2734 14.696C14.9569 14.696 14.6901 14.6327 14.473 14.5061C14.256 14.3795 14.0796 14.2031 13.9439 13.977C13.8083 13.7509 13.7088 13.4796 13.6455 13.163C13.5822 12.8465 13.5505 12.4983 13.5505 12.1184C13.5505 11.2321 13.7269 10.5809 14.0796 10.1649C14.4323 9.74883 14.9162 9.54082 15.5312 9.54082C16.0919 9.54082 16.5532 9.62674 16.915 9.79858V13.2716C16.8064 13.7599 16.621 14.1194 16.3587 14.3501Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

HealthGrades.propTypes = propTypes;
HealthGrades.defaultProps = defaultProps;

export default HealthGrades;
